module.exports = __webpack_public_path__ + "dd8e5bbccfea3c49e789be078e6be3f2.png";